<template>
  <v-container fluid>
    <v-data-table :headers="headertable1" :items="items">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('pointSale-table-top-t1') }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="nuevoPuntoVenta()"> {{ $t('pointSale-table-top-btn1') }} </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action_edit`]="{ item }">
        <v-icon class="mr-2" @click="editarPuntoVenta(item)">
          fa-solid fa-pen-to-square
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="cod_MH"
                :label="$t('pointSale-dialog-input-label-t1')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="9">
              <v-text-field
                v-model="descripcion"
                :label="$t('pointSale-dialog-input-label-t2')"
                outlined
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="id_sucursal"
                :items="items_sucursales"
                item-text="nombre"
                item-value="id_sucursal"
                :label="$t('pointSale-dialog-input-label-t3')"
                outlined
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="crearPuntoVenta()" v-if="flag == 1"
            >{{ $t('btn-save') }}</v-btn
          >
          <v-btn
            color="primary"
            @click="ActualizarPuntoVenta()"
            v-if="flag == 2"
            >{{ $t('btn-update') }}</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">{{ $t('btn-close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="8000"
      color="blue"
      multi-line
      elevation="24"
      outlined
      top
      right
    >
      <v-icon>{{ icon_snackbar }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    items: [],
    snackbar: false,
    icon_snackbar: "",
    snackbar_text: "...",
    dialog: false,
    id_punto_venta: 0,
    id_empresa: 0,
    cod_MH: "",
    descripcion: "",
    flag: 1,
    id_sucursal: 0,
    items_sucursales: [],
  }),
  created() {
    this.listarPuntosVenta();
    this.listarSucursales();
  },
  computed: {
    headertable1() {
      return [
        {
          text: this.$t("pointSale-table-header-t1"),
          value: "cod_punto_venta_mh",
        },
        { text: this.$t("pointSale-table-header-t2"), value: "descripcion" },
        {
          text: this.$t("pointSale-table-header-t3"),
          value: "nombre_sucursal",
        },
        { text: this.$t("pointSale-table-header-t4"), value: "action_edit" },
      ];
    },
  },
  methods: {
    listarPuntosVenta() {
      axios
        .get("api/PuntoVentas/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          //console.log(response.data);
          this.items = response.data;
        });
    },
    listarSucursales() {
      axios
        .get("api/Sucursales/Listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
        });
    },
    nuevoPuntoVenta() {
      this.dialog = true;
    },
    crearPuntoVenta() {
      axios
        .post("api/PuntoVentas/Crear", {
          id_empresa: this.$store.state.emp.id_empresa,
          id_sucursal: this.id_sucursal,
          cod_punto_venta_mh: this.cod_MH.toUpperCase(),
          descripcion: this.descripcion,
        })
        .then((response) => {
          //console.log(response.data);
          if (response.data == 409) {
            this.snackbar_text = this.$t('pointSale-snackbar-t1');
            this.snackbar = true;
            return;
          }
          this.snackbar_text = this.$t('pointSale-snackbar-t2');
          this.snackbar = true;
          this.cerrarDialog();
          this.listarPuntosVenta();
        })
        .catch(() => {
          this.snackbar_text = this.$t('pointSale-snackbar-t3');
          this.snackbar = true;
        });
    },
    ActualizarPuntoVenta() {
      axios
        .put("api/PuntoVentas/Actualizar", {
          id_punto_venta: this.id_punto_venta,
          id_empresa: this.id_empresa,
          id_sucursal: this.id_sucursal,
          cod_punto_venta_mh: this.cod_MH,
          descripcion: this.descripcion,
        })
        .then(() => {
          this.snackbar_text = this.$t('pointSale-snackbar-t4');
          this.snackbar = true;
          this.cerrarDialog();
          this.listarPuntosVenta();
        })
        .catch(() => {
          this.snackbar_text = this.$t('pointSale-snackbar-t5');
          this.snackbar = true;
        });
    },
    editarPuntoVenta(item) {
      //console.log(item);
      this.id_punto_venta = item.id_punto_venta;
      this.id_empresa = item.id_empresa;
      this.cod_MH = item.cod_punto_venta_mh;
      this.descripcion = item.descripcion;
      this.id_sucursal = item.id_sucursal;

      this.flag = 2;
      this.dialog = true;
    },
    cerrarDialog() {
      this.dialog = false;
      this.flag = 1;

      this.id_punto_venta = 0;
      this.id_empresa = 0;
      this.cod_MH = "";
      this.descripcion = "";
      this.id_sucursal = 0;
    },
  },
};
</script>